import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UserManagementService = /** @class */ (function () {
    function UserManagementService(http) {
        this.http = http;
    }
    UserManagementService.prototype.getActivityLogs = function (params) {
        var url = '/dashboard/v1/hansel/user-logs/query';
        return this.http.post(url, params).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    UserManagementService.prototype.getUsers = function (params) {
        var url = '/dashboard/getusersofcompany';
        return this.http.get(url, { 'params': params }).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    UserManagementService.prototype.inviteUsers = function (payload) {
        var url = '/dashboard/inviteuserstocompany';
        payload['dashboard_version'] = '3.0';
        if (payload.resendInvite) {
            payload['resend_email'] = 1;
        }
        return this.http.post(url, payload).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    UserManagementService.prototype.deleteUser = function (uid) {
        var url = '/dashboard/deleteuser?user_id=' + uid;
        return this.http.delete(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    UserManagementService.ngInjectableDef = i0.defineInjectable({ factory: function UserManagementService_Factory() { return new UserManagementService(i0.inject(i1.HttpClient)); }, token: UserManagementService, providedIn: "root" });
    return UserManagementService;
}());
export { UserManagementService };
